<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 ">
  <loading v-if="loadingState" />
  <div v-if="!hideData && !orderRemoved" class="container  pb-5">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <div class="col-md-12">
      <h3 v-if="item.flow != 'mbfacta_recovery'" class="Regular h0 widthFull"><b>Conferma Preventivo N. {{item.code}}</b></h3>
      <h3 v-else class="Regular h0 widthFull"><b>Conferma Pratica N. {{item.code}}</b></h3>

      <p class="black mt-0 text-left widthFull">

        Verifica e completa i dati mancanti per la conferma del Preventivo
      </p>
      </div>
    </div>

    <form class="pb-5 pt-4  black vaillantCont widthFull" id="registration-form">

      <div v-if="item.flow != 'agileenergy'" class="row justify-content-center pb-5 ">

        <!-- TITLE CLIENT INFO -->
        <div class="col-md-12">
          <h4 v-if="item.client_type != 'Amministratore di condominio'" class="widthFull center black">
            Completa i dati mancanti del cliente finale (<b>{{item.client_name}} {{item.client_lastname}}</b>)
          </h4>
          <h4 v-else class="widthFull center black">
            Completa i dati mancanti dell'Amministratore del condominio (<b>{{item.client_name}} {{item.client_lastname}}</b>)
          </h4>
        </div>


        <!-- CLIENT LASTNAME INPUT ROW 1 -->
        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" autocomplete="randomq" class="form-control" v-model="item.client_lastname" id="clientLastname" name="clientLastname" data-vv-as="Cognome" v-validate="{required:true, max: 63, min: 2}"
              :class="{ 'is-invalid': errors.has('clientLastname'), valid: !!item.client_lastname }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="clientLastname">Cognome *</label>
            <div v-if="errors.has('clientLastname')" class="invalid-feedback">
              {{ errors.first("clientLastname") }}
            </div>
          </div>
        </div>

        <!-- CLIENT NAME INPUT ROW 1 -->
        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" autocomplete="randomq" class="form-control" v-model="item.client_name" id="clientName" name="clientName" data-vv-as="Nome" v-validate="{required:true, max: 63, min: 2}"
              :class="{ 'is-invalid': errors.has('clientName'), valid: !!item.client_name }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="clientName">Nome *</label>
            <div v-if="errors.has('clientName')" class="invalid-feedback">
              {{ errors.first("clientName") }}
            </div>
          </div>
        </div>


        <div class="col-md-4 mb-3 ">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" v-model="item.client_email" class="form-control" id="email" name="email" ref="email" data-vv-as="Email" v-validate="{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
              :class="{ 'is-invalid': errors.has('email'), valid: !!item.client_email }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="email">Email* </label>

            <div v-if="errors.has('email')" class="invalid-feedback">
              {{ errors.first("email") }}
            </div>
          </div>
        </div>

        <div v-if="item.client_type == 'Persona fisica' || item.client_type == 'Amministratore di condominio'" class="col-md-4">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" class="form-control" v-model="codice_fiscale" id="codice_fiscale" name="codice_fiscale" data-vv-as="Codice Fiscale" v-validate="{required: true, codiceFiscale: codice_fiscale.length > 11 ? true : false , partitaIva: codice_fiscale.length <= 11 ? true : false,  max: 16, min: 11}"
              :class="{ 'is-invalid': errors.has('codice_fiscale'), valid: !!codice_fiscale }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="codice_fiscale">Codice Fiscale *</label>

            <div v-if="errors.has('codice_fiscale')" class="invalid-feedback">
              {{ errors.first("codice_fiscale") }}
            </div>
          </div>
        </div>


        <div v-else-if="item.client_type == 'Partita IVA'" class="col-md-4">

          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" class="form-control" v-model="partita_iva" id="partita_iva" name="partita_iva" data-vv-as="Partita IVA" v-validate="{required: true, partitaIva: true, max: 11, min: 11}"
              :class="{ 'is-invalid': errors.has('partita_iva'), valid: !!partita_iva }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="partita_iva">Partita IVA *</label>

            <div v-if="errors.has('partita_iva')" class="invalid-feedback">
              {{ errors.first("partita_iva") }}
            </div>
          </div>

        </div>

        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" class="form-control" v-model="item.client_phone" id="phone" name="phone" data-vv-as="Telefono" v-validate="{required: item.client_mobile ? false : true, max: 12, min: 8, regex: /^[0,3]+/}"
              :class="{ 'is-invalid': errors.has('phone'), valid: !!item.client_phone }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="phone">Telefono </label>
            <div v-if="errors.has('phone')" class="invalid-feedback">
              {{ errors.first("phone") }}
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" class="form-control" v-model="item.client_mobile" id="mobile" name="mobile" data-vv-as="Cellulare" v-validate="{required: item.client_phone ? false : true, max: 12, min: 8, regex: /^[0,3]+/}"
              :class="{ 'is-invalid': errors.has('mobile'), valid: !!item.client_mobile }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="mobile">Cellulare * </label>
            <div v-if="errors.has('mobile')" class="invalid-feedback">
              {{ errors.first("mobile") }}
            </div>
          </div>
        </div>


      </div>
      <div class="row justify-content-center pb-5 ">

        <!-- NEWWWWWW TITLE CODICE FISCALE PROPRIETARIO -->
        <div class="col-md-12">
          <h4 class="widthFull center black">
            Conferma la titolarità dell'immobile oggetto dell'intervento
          </h4>
        </div>

        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <select type="text" autocomplete="randomq" class="form-control" v-model="client_owner_type" id="client_owner_type" name="client_owner_type" data-vv-as="Titolo di possesso" v-validate="{required:true, max: 123, min: 2}"
              :class="{ 'is-invalid': errors.has('form-1.client_owner_type'), valid: !!client_owner_type }">

              <option value="Proprietario o comproprietario">Proprietario o comproprietario</option>
              <option value="Detentore o co-detentore">Detentore o co-detentore (es. locatario, comodatario, usufruttuario, ecc.)</option>
              <option value="Familiare convivente">Familiare convivente con il possessore o con il detentore</option>
              <option v-if="client_type == 'Amministratore di condominio'" value="Condominio">Condominio</option>

            </select>
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="client_owner_type">Titolo di possesso / diritto reale *</label>
            <div v-if="errors.has('form-1.client_owner_type')" class="invalid-feedback">
              {{ errors.first("form-1.client_owner_type") }}
            </div>
          </div>
        </div>

        <div v-if="client_owner_type != 'Proprietario o comproprietario' && client_owner_type != '' " class="col-md-6 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" autocomplete="randomq" data-vv-validate-on="blur" class="form-control" v-model="client_owner_codice_fiscale" id="client_owner_codice_fiscale" name="client_owner_codice_fiscale"
              data-vv-as="P.IVA o codice fiscale del proprietario"
              v-validate="{required:true, partitaIva: client_owner_codice_fiscale.length == 11 ? true : false, codiceFiscale: client_owner_codice_fiscale.length == 16 ? true : false, max: client_owner_codice_fiscale.length < 11 ? 16 : 16, min: client_owner_codice_fiscale.length > 11 ? 16 : 11}"
              :class="{ 'is-invalid': errors.has('client_owner_codice_fiscale'), valid: !!client_owner_codice_fiscale }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="client_owner_codice_fiscale"> P.Iva o Codice Fiscale <small> del proprietario dell'immobile *</small> </label>

            <div v-if="errors.has('client_owner_codice_fiscale') " class="invalid-feedback">
              {{ errors.first("client_owner_codice_fiscale") }}
            </div>
          </div>
        </div>




        <!-- TITLE CLIENT INFO -->
        <div class="col-md-12">

          <h4 class="widthFull center black">
            Indirizzo dell'immobile oggetto dell'intervento: <br/> <b>{{item.building_address}} {{item.building_civic}} - {{ item.building_zip }} {{ item.building_city }} ({{ item.building_province }})</b>
          </h4>
        </div>

        <div class="col-md-6"> </div>
        <div class="col-md-12">
          <h4 v-if="item.client_type != 'Amministratore di condominio' /*&& item.to_get_cadastral_data != '1'*/" class="widthFull center black pb-0">
            Dati Catastali dell'immobile oggetto dell'intervento
          </h4>

          <p v-if="item.to_get_cadastral_data == '1'" class="center red">
            Se disponibili, compila le seguenti informazioni per una migliore ricerca:
          </p>

        </div>

        <!--<div v-if="item.client_type != 'Amministratore di condominio'" class="col-md-6 mb-3" style="opacity: 0;">
          <div class="group custInput">
            <select type="text" autocomplete="randomq" class="form-control" disabled v-model="client_ownership" id="client_ownership" name="client_ownership" data-vv-as="Titolo di possesso" v-validate="{required:true, max: 63, min: 2}"
              :class="{ 'is-invalid': errors.has('client_ownership'), valid: !!client_ownership }">
              <option value="Proprietario">Proprietario</option>
              <option value="Usufruttuario">Usufruttuario</option>
              <option value="Locatario">Locatario</option>
              <option value="Promissario acquirente">Promissario acquirente</option>
              <option value="Familiare convivente del possessore/detentore">Familiare convivente del possessore/detentore</option>
              <option value="Erede">Erede</option>
              <option value="Coniuge separato assegnatario">Coniuge separato assegnatario</option>
              <option value="Socio di cooperativa a proprietà indivisa">Socio di cooperativa a proprietà indivisa</option>
              <option value="Socio di cooperativa a proprietà divisa">Socio di cooperativa a proprietà divisa</option>
            </select>
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="client_ownership">Titolo di possesso *</label>
            <div v-if="errors.has('client_ownership')" class="invalid-feedback">
              {{ errors.first("client_ownership") }}
            </div>
          </div>
        </div>-->


        <div v-if="1==1 /* item.client_type != 'Amministratore di condominio' && item.to_get_cadastral_data != '1'*/" class="col-md-2 mb-3 ">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" v-model="foglio" class="form-control" id="foglio" name="foglio" ref="foglio" data-vv-as="foglio" v-validate="{required:item.to_get_cadastral_data != '1' ? true : false,  max: 10, min: 1}"
              :class="{ 'is-invalid': errors.has('foglio'), valid: !!foglio }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="foglio">Foglio <template v-if="item.to_get_cadastral_data != '1'">*</template> </label>

            <div v-if="errors.has('foglio')" class="invalid-feedback">
              {{ errors.first("foglio") }}
            </div>
          </div>
        </div>

        <div v-if="1==1 /*item.client_type != 'Amministratore di condominio' /*&& item.to_get_cadastral_data != '1'*/" class="col-md-2 mb-3 ">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" v-model="particella" class="form-control" id="particella" name="particella" ref="particella" data-vv-as="particella" v-validate="{required:item.to_get_cadastral_data != '1' ? true : false, max: 10, min: 1}"
              :class="{ 'is-invalid': errors.has('particella'), valid: !!particella }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="particella">Particella <template v-if="item.to_get_cadastral_data != '1'">*</template> </label>

            <div v-if="errors.has('particella')" class="invalid-feedback">
              {{ errors.first("particella") }}
            </div>
          </div>
        </div>

        <div v-if="1==1 /*item.client_type != 'Amministratore di condominio' /*&& item.to_get_cadastral_data != '1'*/" class="col-md-2 mb-3 ">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" v-model="subalterno" class="form-control" id="subalterno" name="subalterno" ref="subalterno" data-vv-as="subalterno" v-validate="{required: item.to_get_cadastral_data != '1' ? true : false, max: 10, min: 1}"
              :class="{ 'is-invalid': errors.has('subalterno'), valid: !!subalterno }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="subalterno">Subalterno <template v-if="item.to_get_cadastral_data != '1'">*</template> </label>

            <div v-if="errors.has('subalterno')" class="invalid-feedback">
              {{ errors.first("subalterno") }}
            </div>
          </div>
        </div>

      </div>
      <div v-if="item.flow != 'agileenergy'" class="row justify-content-center pb-5 ">

        <div class="col-md-12">
          <h4 v-if="item.client_type != 'Partita IVA'" class="widthFull center black pb-4">
            <!-- Indirizzo di residenza <span v-if="item.client_type != 'Amministratore di condominio'">(modifica se necessario)</span> -->
            Indirizzo di residenza del cliente ( solo se diverso dall'indirizzo dell'immobile oggetto dell'intervento )
          </h4>
          <h4 v-else class="widthFull center black pb-4">
            <!-- Indirizzo di residenza <span v-if="item.client_type != 'Amministratore di condominio'">(modifica se necessario)</span> -->
            Indirizzo Sede Legale ( solo se diverso dall'indirizzo dell'immobile oggetto dell'intervento  )
          </h4>
        </div>

        <!-- PROVINCE INPUT ROW 2 -->
        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <select v-model="province" autocomplete="randomy" id="province" name="province" class="form-control" data-vv-as="Provincia" v-validate="{required:true}" :class="{ 'is-invalid': errors.has('province'), valid: !!province }">
              <option disabled value="" selected="selected"></option>
              <option :key="2341253542" v-bind:value="'SE'">
                STATO ESTERO
              </option>
              <option v-for="province in provincies" :key="province.sigla" v-bind:value="province.sigla">
                {{province.sigla}} - {{province.provincia}}
              </option>
            </select>
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="province">Provincia *</label>
            <div v-if="provinciesState">
              <font-awesome-icon class="loadSpinner" id="loadProvince" icon="spinner" size="1x" pulse />
            </div>
            <div v-if="errors.has('province')" class="invalid-feedback">
              {{ errors.first("province") }}
            </div>
          </div>
        </div>
        <!-- CITY INPUT ROW 2 -->
        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <span v-if="cityError" class="formError">Prima scegli Provincia</span>

            <select v-if="province != 'SE'" class="form-control" autocomplete="randomu" v-model="city" v-on:click="checkProvince" id="city" name="city" data-vv-as="Località" v-validate="{required:true}" :disabled="citiesState"
              :class="{ 'is-invalid': errors.has('city'), valid: !!city }">
              <option disabled value="" selected="selected"></option>

              <option v-for="city in cities" :key="city.comune" v-bind:value="{cityistat: city.istat, city: city.comune}">
                {{city.comune}}
              </option>
            </select>

            <input v-else class="form-control" autocomplete="randomu" v-model="citySE" id="citySE" name="citySE" data-vv-as="Località" v-validate="{required:true}" :disabled="citiesState"
              :class="{ 'is-invalid': errors.has('citySE'), valid: !!citySE }">


            <span class="highlight"></span>
            <span class="bar"></span>
            <label v-if="province != 'SE'" class="niceInputLabel" for="city">Località *</label>
            <label v-else class="niceInputLabel" for="city">Località e Paese*</label>

            <div v-if="citiesState">
              <font-awesome-icon class="loadSpinner" id="loadCity" icon="spinner" size="1x" pulse />
            </div>
            <div v-if="errors.has('city')" class="invalid-feedback">
              {{ errors.first("city") }}
            </div>
            <div v-if="errors.has('citySE')" class="invalid-feedback">
              {{ errors.first("citySE") }}
            </div>
          </div>
        </div>
        <!-- ZIP INPUT ROW 2 -->
        <div class="col-md-4 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <span v-if="zipError" class="formError">Prima scegli città</span>

            <select v-if="province != 'SE'" class="form-control" autocomplete="randomi" v-model="zip" v-on:click="checkZip" id="zip" name="zip" data-vv-as="CAP" v-validate="{required:true}" :disabled="zipsState"
              :class="{ 'is-invalid': errors.has('zip'), valid: !!zip }">
              <option value="" disabled :selected="true"></option>
              <option v-for="zip in zips" :key="zip.cap" v-bind:value="zip.cap">
                {{zip.cap}}
              </option>
            </select>

            <input v-else class="form-control" autocomplete="randomi" v-model="capSE" id="capSE" name="capSE" data-vv-as="CAP" v-validate="{required:true, min:5, max:5}" :disabled="zipsState"
              :class="{ 'is-invalid': errors.has('capSE'), valid: !!capSE }">


            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="zip">CAP *</label>
            <div v-if="zipsState">
              <font-awesome-icon class="loadSpinner" id="loadZips" icon="spinner" size="1x" pulse />
            </div>
            <div v-if="errors.has('zip')" class="invalid-feedback">
              {{ errors.first("zip") }}
            </div>
            <div v-if="errors.has('capSE')" class="invalid-feedback">
              {{ errors.first("capSE") }}
            </div>
          </div>
        </div>

        <!-- ADDRESS INPUT ROW 3 -->
        <div class="col-md-6 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" autocomplete="randomq" class="form-control" v-model="address" id="address" name="address" data-vv-as="Indirizzo" v-validate="{required:true, max: 128, min: 5}"
              :class="{ 'is-invalid': errors.has('address'), valid: !!address }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="address">Indirizzo *</label>
            <div v-if="errors.has('address')" class="invalid-feedback">
              {{ errors.first("address") }}
            </div>
          </div>
        </div>

        <!-- CIVIC INPUT ROW 3 -->
        <div class="col-md-6 mb-3">
          <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
            <input type="text" autocomplete="randomq" class="form-control" v-model="civic" id="civic" name="civic" data-vv-as="N. Civico" v-validate="{required:true, max: 15, min: 1}" :class="{ 'is-invalid': errors.has('civic'), valid: !!civic }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="civic">N. Civico *</label>
            <div v-if="errors.has('civic')" class="invalid-feedback">
              {{ errors.first("civic") }}
            </div>
          </div>
        </div>


      </div>
      <div  class="row justify-content-center pb-5 ">

        <div class="col-md-6">

          <h4 v-if="item.flow != 'agileenergy'" class="widthFull center black">
            Carica il Preventivo accettato e firmato dal cliente
          </h4>
          <h4 v-else class="widthFull center black">
            Carica il  Contratto <br/> per la fornitura e l’installazione <br/> firmato dal Cliente
          </h4>
          <p class="center">
            Se necessario è possibile caricare piu file
            ( formati: JPG, PNG, PDF. )
          </p>

          <div class="front-image">

            <input type="file" v-on:change="uploadFile" ref="fileInput" multiple name="invoiceFront" id="invoiceFront" class="fileInput" :data-vv-as=" item.flow != 'agileenergy' ? 'Preventivo accettato e firmato dal cliente' : 'Contratto per la fornitura e l’installazione'"
              v-validate="{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
              :class="{ 'is-invalid': errors.has('invoiceFront'), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">

            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel labelFileInput" for="invoiceFront">

              <span v-if="!invoiceFrontName" class="smallText center white" :style="{ backgroundImage: 'url(' + invoiceFrontBucket + ')' }">
                <p v-if="!invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0">Scegli il Contratto quadro*</p>
              </span>

              <span v-else class="smallText center white" :style="{  backgroundImage: 'url(' + invoiceFrontBucket + ')' }">

              </span>

            </label>

            <div v-if="errors.has('invoiceFront')" class="invalid-feedback" style="top:185px">
              {{ errors.first('invoiceFront') }}
            </div>

            <div v-if="uploadFrontPercentage" class="progress mt-5" id="progFront">
              <div class="progress-bar " id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                {{ uploadFrontPercentage }} %
              </div>
            </div>

            <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>

          </div>


        </div>


        <div v-if="item.flow == 'agileenergy'" class="col-md-6">

          <h4 class="widthFull center black">
            Carica la Lettera di Affidamento <br/> firmata e timbrata dall'installatore <br/> professionista in subappalto
          </h4>
          <p class="center">
            Se necessario è possibile caricare piu file
            ( formati: JPG, PNG, PDF. )
          </p>

          <div class="front-image">

            <input type="file" v-on:change="uploadFile2" ref="fileInput2" multiple name="invoiceRear" id="invoiceRear" class="fileInput2" data-vv-as="Lettera di Affidamento"
              v-validate="{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
              :class="{ 'is-invalid': errors.has('invoiceRear'), valid: !!invoiceRear, helper: !!invoiceRearBucket }">

            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel labelFileInput" for="invoiceRear">

              <span v-if="!invoiceRearName" class="smallText center white" :style="{ backgroundImage: 'url(' + invoiceRearBucket + ')' }">
                <p v-if="!invoiceRearName" class="smallText center white mt-3 mb-0 pb-0">Scegli il Contratto quadro*</p>
              </span>

              <span v-else class="smallText center white" :style="{  backgroundImage: 'url(' + invoiceRearBucket + ')' }">

              </span>

            </label>

            <div v-if="errors.has('invoiceRear')" class="invalid-feedback" style="top:185px">
              {{ errors.first('invoiceRear') }}
            </div>

            <div v-if="uploadRearPercentage" class="progress mt-5" id="progRear">
              <div class="progress-bar " id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadRearPercentage + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                {{ uploadRearPercentage }} %
              </div>
            </div>

            <p v-if="invoiceRearName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceRearName}}</p>

          </div>


        </div>


        <div class="col-md-12 mt-5 mb-3 center">

          <a v-if="invoiceFrontBucket" v-bind:href="invoiceFrontBucket" target="_blank">
            <a v-if="invoiceFrontBucket.substring(invoiceFrontBucket.lastIndexOf('.')+1, invoiceFrontBucket.length) == 'pdf'" class="center widthFull pdfLink" v-bind:href="invoiceFrontBucket" target="_blank">APRI PDF</a>
          </a>

        </div>

        <div class="col-md-12 center mt-5 pt-4">
          <button type="button" v-on:click="convertToPractice" class="btn btn-primary btnRed">Procedi</button>
        </div>


      </div>

    </form>


  </div>

  <div v-if="hideData && !orderRemoved" class="container pt-4 mt-5">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <h3 class="Regular center h0 widthFull"><b>Accetta preventivo N. {{item.code}}</b></h3>
      <p class="black mt-0 text-center widthFull">
        Hai completatto correttamente la pratica.
      </p>
    </div>

  </div>

  <div v-if="orderRemoved" class="container pt-5 mt-5 ">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left vaillantCont">

      <h3 class="Regular center h0 widthFull"><b>ATTENZIONE! <br /> <br /> <br /> Preventivo N. {{item.code}} <br /> <br /> è stato eliminato </b></h3>
      <p class="black mt-0 text-center widthFull">

      </p>
    </div>

  </div>

</div>

</div>
</template>

<script>
import {
  USER_REQUEST
} from 'actions/user'

import {
  AUTH_REQUEST,
  AUTH_SOCIAL,
  SET_USER_TOKEN
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import {
  ADD_NOTIFICATIONS,
  GET_NOTIFICATIONS
} from 'actions/notifications'

import axios from 'axios'

const moment = require('moment')

export default {
  name: 'acceptInvoice',
  components: {

  },
  data() {
    return {
      token: '',

      citySE: '',
      capSE: '',

      //NEWWWW 222
      client_owner_type: '',
      client_owner_codice_fiscale: '',

      loadingState: false,
      loading: false,
      practices: {},
      moment: require('moment'),
      item: {},
      hideData: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      mobile: '',
      cellulare: '',
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,

      invoiceRear: '',
      invoiceRearName: '',
      invoiceRearBucket: '',
      uploadRearPercentage: 0,

      client_ownership: '',
      subalterno: '',
      particella: '',
      foglio: '',
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      brand: process.env.BRAND,
    }
  },
  methods: {
    convertToPractice: function() {
      var _vue = this
      console.log(this.$validator)
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loadingState = true
          // PREPARE
          var data = {}
          data.client_email = this.item.client_email
          data.client_codice_fiscale = this.codice_fiscale
          data.client_partita_iva = this.partita_iva
          data.client_phone = this.item.client_phone
          data.client_mobile = this.item.client_mobile
          data.client_address = this.address
          data.client_civic = this.civic

          // NEW DISPOSAL
          data.disposal = 0

          if (this.province != 'SE') {
            data.client_province = this.province
            data.client_city = this.city.city
            data.client_zip = this.zip
          } else {
            data.client_province = this.province
            data.client_city = this.citySE
            data.client_zip = this.capSE
          }


          data.client_ownership = this.client_ownership

          data.building_subalterno = this.subalterno
          data.building_particella = this.particella
          data.building_foglio = this.foglio
          data.practice_id = this.item.id

          data.date_accept_offer = moment().format('YYYY-MM-DD HH:mm:ss')

          data.code = this.item.code

          if (this.tokenControl) {
            data.user_token = this.$route.query.t
          } else {
            data.user_token = this.getProfile.userToken
          }

          data.signed_order = this.invoiceFrontBucket

          // NEW CODICE FISCALE PROPRIETARIO PER DCAST
          data.client_owner_type = this.client_owner_type
          if ( this.client_owner_type == 'Proprietario o comproprietario' ){
            data.client_owner_codice_fiscale = '';
          }else{
            data.client_owner_codice_fiscale = this.client_owner_codice_fiscale;
          }


          if( this.item.flow == 'agileenergy' ){
            data.practice = this.item
            data.lettera_di_affidamento_signed = this.invoiceRearBucket
          }

          axios({
              url: process.env.ROOT_API + 'api/acceptOrder',
              method: 'POST',
              data: data,
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              console.log(resp)

              _vue.loadingState = false

              if( this.item.flow == 'agileenergy' ){

                _vue.$swal({
                  type: 'success',
                  title: '',
                  html: 'La Lettera di Affidamento ed il Contratto per la fornitura e l’installazione sono in verifica. A seguito dell`approvazione verranno inviate al Committente all`indirizzo e-mail le indicazioni per procedere al pagamento della quota parte relativa alla voce “Totale altri Oneri per il Committente” '
                });

                _vue.$router.push('/offerte')

              }else{

                if (_vue.tokenControl) {

                  _vue.$swal({
                    type: 'success',
                    title: 'Pratica Inizializzata',
                    html: 'Abbiamo creato la pratica <b>' + this.item.code +
                      '</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. ',
                  });

                  _vue.hideData = true

                } else {

                  _vue.$swal({
                    type: 'success',
                    title: 'Pratica Inizializzata',
                    html: 'Abbiamo creato la pratica <b>' + this.item.code +
                      '</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. ',
                  });

                }

                _vue.$router.push('/pratiche')
              }

            })
            .catch(resp => {
              _vue.loadingState = false
              _vue.$swal({
                type: 'error',
                title: 'Oops...',
                text: 'Riprova piu tardi!',
              });
            })


        } else {
          console.log('ERROR IN FORM')
          _vue.$scrollTo('#' + _vue.errors.items[0].field, 700, {
            offset: -170
          })
        }
      })
    },
    populateProvincies: function() {
      const {
        provincies,
        provinciesState
      } = this
      axios({
          url: process.env.ROOT_API + 'api/getProvinciesAll',
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false

        })
        .catch(resp => {
          this.provincies = [];
          this.provinciesState = false
        })
    },
    async checkUserToken(token) {
      console.log('QRcode CHECK TOKEN')
      await axios({
          url: process.env.ROOT_API + 'api/tokenControl',
          method: 'POST',
          data: {
            'user_token': token
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          console.log('QRcode CHECK TOKEN => OK')
          this.tokenControl = true
        })
        .catch(resp => {
          console.log('QRcode CHECK TOKEN => ERROR')
          this.tokenControl = false
        })
    },

    async getPracticById(userToken, id) {
      console.log('GET PRACTIC FOR QRcode ENTER')
      await axios({
          url: process.env.ROOT_API + 'api/getPracticById',
          method: 'POST',
          data: {
            'user_token': userToken,
            'id': id
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          console.log('GET PRACTIC FOR QRcode => OK')
          // CHECK IF ACTIVE YET

          this.$route.params.item = resp.data.practices[0]

          // MENU OFF FOR THIS CASE
          var alert = {}
          alert.text = 'NOT LOGED VIEW'
          alert.type = 'MENU_OFF'
          //this.$store.dispatch(ADD_NOTIFICATIONS, alert)

        })
        .catch(resp => {
          console.log('GET PRACTIC FOR QRcode => ERROR')
          this.tokenControl = false
        })
    },
    checkProvince: function() {

      const {
        province
      } = this
      if (province) {
        this.cityError = false
      } else {
        this.cityError = true
      }

    },
    checkZip: function() {
      const {
        city
      } = this
      if (city) {
        this.zipError = false
      } else {
        this.zipError = true
      }
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    },
    UploadError() {
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Errore caricamento immagine',
      });
    },
    async setCap(cap) {
      for (var x in this.zips) {
        if (this.zips[x].cap == cap.toUpperCase()) {
          this.zip = this.zips[x].cap
        }
      }

    },
    async setCity(city) {

      for (var x in this.cities) {
        if (this.cities[x].comune == city.toUpperCase()) {
          var k = {
            cityistat: this.cities[x].istat,
            city: city.toUpperCase(),
          }
          this.city = k
        }
      }
      console.log(this.city)

    },
    async setProvince(province) {

      for (var x in this.provincies) {
        if (this.provincies[x].sigla == province.toUpperCase()) {
          this.province = this.provincies[x].sigla
        }
      }
      console.log(this.province)

    },
    uploadFile: function(input) {
      var file = input.target.files[0].name
      this.invoiceFrontName = file
      var extension = file.substr((file.lastIndexOf('.') + 1)).toLowerCase()
      var size = input.target.files[0].size


      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name
        var formData = new FormData();
        var _vue = this // << here
        var t = 0
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1
        }

        this.loadingState = true

        axios.post(process.env.ROOT_API + 'api/uploadImageInvoice',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              },
              onUploadProgress: function(progressEvent) {
                this.uploadFrontPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
              }.bind(this)
            }
          ).then(function(e) {
            var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.fattura)) {
              _vue.loadingState = false
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFrontBucket = e.data.fattura

            } else {
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFront = ''
              _vue.invoiceFrontBucket = ''
              _vue.UploadError()
              input.target.value = null
              _vue.loadingState = false
            }

          })
          .catch(function() {
            _vue.uploadFrontPercentage = 0
            _vue.invoiceFront = ''
            _vue.invoiceFrontBucket = ''
            _vue.UploadError()
            input.target.value = null
            _vue.loadingState = false

          });
      }

    },

    uploadFile2: function(input) {
      var file = input.target.files[0].name
      this.invoiceRearName = file
      var extension = file.substr((file.lastIndexOf('.') + 1)).toLowerCase()
      var size = input.target.files[0].size


      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceRear = input.target.files[0].name
        var formData = new FormData();
        var _vue = this // << here
        var t = 0
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1
        }

        this.loadingState = true

        axios.post(process.env.ROOT_API + 'api/uploadImageInvoice',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              },
              onUploadProgress: function(progressEvent) {
                this.uploadRearPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
              }.bind(this)
            }
          ).then(function(e) {
            var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.fattura)) {
              _vue.loadingState = false
              _vue.uploadRearPercentage = 0
              _vue.invoiceRearBucket = e.data.fattura

            } else {
              _vue.uploadRearPercentage = 0
              _vue.invoiceRear = ''
              _vue.invoiceRearBucket = ''
              _vue.UploadError()
              input.target.value = null
              _vue.loadingState = false
            }

          })
          .catch(function() {
            _vue.uploadRearPercentage = 0
            _vue.invoiceRear = ''
            _vue.invoiceRearBucket = ''
            _vue.UploadError()
            input.target.value = null
            _vue.loadingState = false

          });
      }

    },

    async enterPassword(token) {

      try {
        const alert = await this.$swal({
          title: 'Password',
          html: `Inserisci la password con cui ti sei registrato alla piattaforma. <br/>`,
          input: 'text',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Entra',
          cancelButtonText: 'Esci',
          allowOutsideClick: false,
          showLoaderOnConfirm: true,
          preConfirm: (alert) => {
            if (alert == '') {
              this.$swal.showValidationMessage(
                `Il campo password richiesto`
              )
            } else {
              //CHECK PASSWORD
              return axios({
                  url: process.env.ROOT_API + 'api/passwordControl',
                  method: 'POST',
                  data: {
                    'user_token': token,
                    'password': alert.trim()
                  },
                  headers: {
                    'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                    'Content-type': 'application/json'
                  }
                })
                .then(resp => {
                  console.log('QRcode CHECK PASSWORD => OK')
                  this.passwordControl = true
                  return true
                })
                .catch(resp => {
                  this.passwordControl = false
                  this.$swal.showValidationMessage(
                    `Password errata`
                  )
                  return false
                })

            }
          }
        })

        return !!(alert);
      } catch (e) {
        return false;
      }


    }
  },
  watch: {
    adress: function(val) {
      if (val) {
        this.adress = this.adress.toUpperCase()
      }
    },
    civic: function(val) {
      if (val) {
        this.civic = this.civic.toUpperCase()
      }
    },
    phone: function(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },

    capSE: function(val) {
      if (val) {
        this.capSE = val.replace(/\D+/g, '');
      }
    },

    mobile: function(val) {
      if (val) {
        this.mobile = val.replace(/\D+/g, '');
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function(newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = ''
      this.cityError = false
      this.zipError = false

      if (newProvince) {
        this.citiesState = true
        axios({
            url: process.env.ROOT_API + 'api/getComuni',
            method: 'POST',
            data: {
              provincia: newProvince
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            this.cities = resp.data.cities
            this.citiesState = false
          })
          .catch(resp => {
            this.cities = [];
            this.citiesState = false
          })
      }

    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function(newCity) {
      this.zipError = false
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true
        axios({
            url: process.env.ROOT_API + 'api/getCap',
            method: 'POST',
            data: {
              istat: newCity.cityistat
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            this.zips = resp.data.zips;
            this.zipsState = false
          })
          .catch(resp => {
            this.zips = [];
            this.zipsState = false
          })
      }

    },
  },
  created() {

  },
  async mounted() {

    //http://localhost:8080/acceptInvoice?crt=38&t=9697a3c74a75d1393ce15644af776053
    console.log(this.$route)

    if (this.$route.query.crt && this.$route.query.t) {
      console.log('QRcode ACCEPT INVOICE')

      await this.enterPassword(this.$route.query.t)

      if (this.passwordControl) {
        // CHECK USER TOKEN
        this.fromQRcode = true
        await this.checkUserToken(this.$route.query.t)

        if (this.tokenControl) {

          // LOGIN USER
          localStorage.setItem('user-token', this.$route.query.t)

          this.$store.dispatch(SET_USER_TOKEN, this.$route.query.t)

          await this.getPracticById(this.$route.query.t, this.$route.query.crt)

        }

      } else {
        this.$router.push('/')
      }

    }

    if (this.$route.params.item) {
      this.item = this.$route.params.item

      // CHECK IF ORDER OR PRACTICE
      if (this.$route.params.item.status == '0') {
        console.log(0)
        if (this.item && this.item.client_type != 'Amministratore di condominio') {
          this.address = this.item.building_address
          this.civic = this.item.building_civic

          if (this.item.client_codice_fiscale) {
            this.codice_fiscale = this.item.client_codice_fiscale
          }
          if (this.item.client_partita_iva) {
            this.partita_iva = this.item.client_partita_iva
          }

          this.client_ownership = this.item.client_ownership

          // NEWWWWWW
          if (this.item.client_owner_type) {
            this.client_owner_type = this.item.client_owner_type
          }

          if (this.item.client_owner_codice_fiscale) {
            this.client_owner_codice_fiscale = this.item.client_owner_codice_fiscale
          }


        }
      } else if (this.$route.params.item.status == '1') {
        console.log(11)
        this.$router.push({
          name: 'loadDocuments',
          params: {
            item: this.item
          }
        })
      } else if (this.$route.params.item.status == '9') {
        this.orderRemoved = true
      } else {
        this.$router.push('/pratiche')
      }


    } else {
      if (!this.tokenControl) {
        this.$router.push('/offerte')
      }
    }

    this.populateProvincies()
    console.log(this.item)

    if (this.item && this.item.client_type != 'Amministratore di condominio') {
      var _vue = this

      console.log("SET REGION")

      setTimeout(async function() {
        console.log("SET PROVINCE" + _vue.item.building_province)
        var province = _vue.item.building_province
        await _vue.setProvince(province)
        console.log("SET PROVINCE SUCCESS")

        setTimeout(async function() {
          console.log("SET CITY")
          var city = _vue.item.building_city
          await _vue.setCity(city)
          console.log("SET CITY SUCCESS")

          setTimeout(async function() {
            console.log("SET CAP")
            var cap = _vue.item.building_zip
            await _vue.setCap(cap)
            console.log("SET CAP SUCCESS")
          }, 1500)

        }, 1500)

      }, 1500)

    }

    this.$scrollTo('#app', 700, {
      offset: -75
    })


  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
    position: absolute;
    bottom: -37px;
    font-size: 17px;
    width: 100%;
    text-align: center;
    color: #0e3d8b!important;
    z-index: 12313;
    white-space: nowrap;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.borderTop {
    border-top: 3px solid #003d13;
    padding-top: 15px;
}

.shopIcon {
    width: 75px;
}

.bigTitle {
    font-size: 47px;
    color: #003d13;

    @media screen and (max-width: $phone) {
        font-size: 27px;
    }

}

.hideFileUpload {
    position: absolute;
    width: 100%;
    height: 110%;
    background: #000000;
    opacity: 0.4;
    top: -18px;
    left: 0;
    filter: blur(24px);
    z-index: 10000;
}

h5 {

    @media screen and (max-width: $phone) {
        font-size: 14px;
    }

}
.corporateImg {
    max-height: 153px;
}
.backImageInvoice {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    > img {
        max-height: 477px;
        margin: 0 auto;
        cursor: pointer;
    }
}

.zoomImage {
    position: absolute;
    left: 48%;
    top: 230px;
    cursor: pointer;
}

.vcenter {
    align-items: center;
    align-self: center;
    vertical-align: middle;
    display: inherit;
}

.front-image {

    position: relative;
    margin: 0 auto;
    display: block;
    height: 177px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 191px;
    margin-bottom: 17px;

    @media screen and (max-width: $tablet) {
        margin-top: 15px!important;
    }

    > .fileInputLabel {
        display: none;
    }

    > .invalid-feedback {
        display: block;
        position: absolute;
        bottom: 15px;
        font-weight: 800;
    }

    > input {
        position: absolute;
        filter: alpha(opacity=0);
        opacity: 0;
        left: 5px;
        width: 100%;
        height: 200px;
        z-index: 10;
        top: -20px;
    }

    > label {
        /*display: none;*/

        width: 100%;
        margin: 0 auto;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        position: relative;
        padding: 0!important !important;
        left: 0;

        > span {
            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            width: 192px;
            margin-top: 19px !important;
            display: block;
            height: 155px;
            margin: 0 auto;
            cursor: pointer;
            word-break: break-all;
            padding: 5px;
            color: white;
            border-radius: 7px;
            overflow-wrap: break-word;
            white-space: normal;
            line-height: 29px;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            align-self: center;
            vertical-align: middle;
            margin: auto;
            display: inline-grid;
            background-size: cover;
            background-position: center;

            &:before {
                content: "+";
                display: block;
                clear: both;
                text-align: center;
                height: 141px;
                width: 179px;
                border-radius: 7px;
                padding-top: 51px;
                font-size: 51px;
                font-weight: 600;
                color: #00917e;
                border: 3px solid #00917e;
            }

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        &:after {
            content: "";
            display: block;

            clear: both;
            text-align: center;
            width: 237px;
            font-size: 10px;
            text-decoration: underline;
            color: black;

            /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        @media screen and (max-width: $phone) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }
        @media screen and (min-width: $phone) and (max-width: $tablet) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }

    }

}

.center-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/acceptInvoice/index.vue